import { createContext } from 'react';
export var CommentSizesContext = /*#__PURE__*/createContext('DEFAULT');